import { GetServerSidePropsContext } from 'next';

import { LWTApiClient } from '@/infrastructures/api/LWTApi';
import { TJwtResponse } from '@/types/responses/login/Login';

const CHECK_LOGGED_IN_PATH = 'concierges/check-logged-in';

export class CheckLoggedInAPI {
  static async post(context?: GetServerSidePropsContext) {
    const apiClient = new LWTApiClient({ context });
    return await apiClient.post<TJwtResponse>(CHECK_LOGGED_IN_PATH);
  }
}
